import { Controller } from '@hotwired/stimulus';
import { transitionSteps, DURATION } from '../lib/step_transition';

// Manages multi-step content within a single modal.
// Slides between steps with a CSS transition.
//
// Usage:
//   <div data-controller="modal-steps">
//     <div data-modal-steps-target="step">Step 1</div>
//     <div data-modal-steps-target="step" class="d-none">Step 2</div>
//     <button data-action="modal-steps#next">Next</button>
//     <button data-action="modal-steps#back">Back</button>
//   </div>
export default class extends Controller {
  static targets = ['step'];

  connect() {
    this.currentIndex = 0;
    this.pendingTimeout = null;
    this.releaseTimeout = null;
    this.transitioning = false;
    this.stepTargets.forEach((step, i) => {
      if (i !== 0) {
        step.classList.add('d-none');
      }
    });

    this.boundNext = () => this.next();
    this.element.addEventListener('modal-steps:next', this.boundNext);
  }

  disconnect() {
    this.element.removeEventListener('modal-steps:next', this.boundNext);
    if (this.pendingTimeout) {
      clearTimeout(this.pendingTimeout);
      this.pendingTimeout = null;
    }
    if (this.releaseTimeout) {
      clearTimeout(this.releaseTimeout);
      this.releaseTimeout = null;
    }
  }

  next() {
    if (this.transitioning) return;
    if (this.currentIndex >= this.stepTargets.length - 1) return;
    this.transitionTo(this.currentIndex + 1, 'forward');
  }

  back() {
    if (this.transitioning) return;
    if (this.currentIndex <= 0) return;
    this.transitionTo(this.currentIndex - 1, 'backward');
  }

  transitionTo(newIndex, direction) {
    if (this.pendingTimeout) {
      clearTimeout(this.pendingTimeout);
    }
    if (this.releaseTimeout) {
      clearTimeout(this.releaseTimeout);
    }

    const current = this.stepTargets[this.currentIndex];
    const next = this.stepTargets[newIndex];

    this.transitioning = true;
    this.pendingTimeout = transitionSteps(current, next, direction);
    this.currentIndex = newIndex;
    this.releaseTimeout = setTimeout(() => {
      this.transitioning = false;
    }, DURATION);
  }
}
